import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { loadMyRoles } from "@/lib/role-presence";

/** Soft Role presence for chrome / home routing (not a hard gate). */
export const checkMyRoles = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => {
    return loadMyRoles(context.supabase, context.userId);
  });
